import { useState } from "react";
import primaryComponents from "../../../../primaryComponents";
import { useUpdateOrderNote } from "../../../../../hooks/api/mutations/useOrder";
import { cleanObject } from "../../../../../helpers";
import { useQueryClient } from "react-query";

export const UpdateOrderNote = ({
  orderDetails = "",
  closeModal = () => {},
}) => {
  const queryClient = useQueryClient();
  const [formData, setFormData] = useState({
    notes: orderDetails?.notes,
  });

  const { mutate: updateOrder, isLoading } = useUpdateOrderNote();
  const handleUpdateOrder = () => {
    updateOrder(
      { id: orderDetails?.id, data: cleanObject({ ...formData }) },
      {
        onSuccess: () => {
          queryClient.invalidateQueries([
            "orderDetails",
            `${orderDetails?.id}`,
          ]);
          closeModal();
        },
      },
    );
  };

  return (
    <div>
      <primaryComponents.TextArea
        value={formData?.notes}
        label={"Order Notes"}
        placeholder={"Add extra informations"}
        onChange={({ target: { value } }) =>
          setFormData((prev) => ({ notes: value }))
        }
      />

      <primaryComponents.Button
        classNames={"btn btn--primary cover"}
        isLoading={isLoading}
        isDisabled={isLoading}
        loadingText={"Updating..."}
        onClick={() => handleUpdateOrder()}
      >
        Continue
      </primaryComponents.Button>
    </div>
  );
};
